import React from 'react';
import {
  Link
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Material-ui
import Button from '@material-ui/core/Button';

//Action
import * as guideAction from '../action/guideAction';

class Comp extends React.Component {


	render() {

		return (
        <div style={{maxWidth:'320px',textAlign:'left'}}>
          <div style={{borderRadius:'10px 10px 0px 0px',background:'#4376AB', padding:'10px'}}>
            <div align='center'>
              <div style={{fontSize:'1.2em',color:'#FFF',textShadow:'1px 1px 1px rgba(0,0,0,0.2)'}}>
                <span className='i-b'>有料サービスなら</span>
                <span className='i-b'>メールが無制限</span>
              </div>

              <div align='center' style={{padding:'5px'}}>
                <Link to='/setting/charge/'>
                  <Button
                    color='secondary'
                    variant="contained"
                    style={{minWidth:'180px'}}
                  >
                    <span style={{fontSize:'1.2em'}}>有料サービスに申し込む</span>
                  </Button>
                </Link>
              </div>
            </div>
          </div>
          <div style={{borderRadius:'0px 0px 10px 10px',background:'#d4dfeb', padding:'10px'}}>
            <ul style={{margin:'5px 5px 5px 25px',color:'#333'}}>
              <li style={{fontSize:'0.9em'}}>送信人数や送信数に制限なし。</li>
              <li style={{fontSize:'0.9em'}}>１通の文字数1000文字まで。</li>
              <li style={{fontSize:'0.9em'}}>審査なしでリアルタイムでお相手に送信できます。</li>
              <li style={{fontSize:'0.9em'}}>お相手の希望条件による制限なし、どなたにでも送信できます。</li>
              <li style={{fontSize:'0.9em'}}>連絡先の交換も自由にできます。</li>
            </ul>

            <div style={{padding:'5px'}}>
              <Button
                variant="outlined"
                color='primary'
                onClick={ () => this.props.guidePaymentSet(true, 'men') }
              >
                有料と無料サービスの違いについて
              </Button>
            </div>
          </div>
        </div>

		)
	}
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...guideAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
